/**
 * NUDIENT: Knappen "Visa mina skal", M-149. Plan: nudient/PLAN-menyknapp.md.
 * Markup i snippets/nudient-cases-cta.liquid. Samma knapp i hjälten,
 * sections/nudient-hero.liquid, och i megamenyns modellrad,
 * snippets/nudient-mega-menu-model-row.liquid. Flyttad från hjältens
 * nudient-hero-gate, M-102.
 *
 * - Knappen är en riktig länk till phone-cases. Med vald modell pekar den på
 *   phone-cases med modellen i filtret, M-013 tillägget punkt 3. Adressen
 *   byggs av getCasesUrl i @nudient/model-store, som menylänken i
 *   assets/nudient-header.js.
 * - Utan vald modell fäller knappen ut väljaren bredvid i stället för att gå
 *   vidare, M-102 punkt 1. Väljaren är den nudient-model-picker som ligger i
 *   samma förälder. Fokus som i väljaren, M-084 tillägget.
 * - Knappens text, "Välj modell" eller "Visa mina skal", byts med CSS på
 *   rotelementets data-model, som modellminnets head-script sätter före
 *   första målningen, i assets/nudient-model-picker.css. Skriptet sätter
 *   data-model-chosen på elementet, så att texten också följer ett val som
 *   inte längre finns bland modellposterna.
 * - Standardmodellen räknas inte som ett val, M-007.
 * - Horizon hämtar om sidhuvudet efter laddningen och skriver då tillbaka
 *   serverns markup, M-085. Elementet och länken bär data-skip-node-update,
 *   och adressen sätts igen när elementet kopplas in på nytt.
 * - Vänsterklick flyttar inte fokus, så att Horizons meny inte stänger
 *   panelen i Safari innan klicket når knappen, nudient/FEL-menyvaljaren.md.
 */

import { findModel, getCasesUrl, getModel } from '@nudient/model-store';

class NudientCasesCta extends HTMLElement {
  #wired = false;

  connectedCallback() {
    this.cta = this.querySelector('[data-nudient-cases-cta]');
    this.picker = this.parentElement?.querySelector('nudient-model-picker') ?? null;
    if (!(this.cta instanceof HTMLAnchorElement)) return;
    if (!this.cta.dataset.nudientOriginalHref) {
      this.cta.dataset.nudientOriginalHref = this.cta.getAttribute('href') || '';
    }
    this.#point();
    if (this.#wired) return;
    this.#wired = true;
    this.cta.addEventListener('click', this.#onClick);
    this.cta.addEventListener('mousedown', this.#onMouseDown);
    document.addEventListener('model:change', this.#point);
  }

  disconnectedCallback() {
    this.cta?.removeEventListener('click', this.#onClick);
    this.cta?.removeEventListener('mousedown', this.#onMouseDown);
    document.removeEventListener('model:change', this.#point);
    this.#wired = false;
  }

  #point = () => {
    if (!this.cta) return;
    const target = getCasesUrl(this.cta.dataset.nudientOriginalHref || '');
    if (target && this.cta.getAttribute('href') !== target) this.cta.setAttribute('href', target);
    this.toggleAttribute('data-model-chosen', Boolean(findModel(getModel())));
  };

  /**
   * Musklick flyttar inte fokus. Efter ett val står fokus på väljarens fält,
   * och i Safari, som inte ger länkar fokus vid klick, stängde Horizons meny
   * annars panelen innan klicket nådde knappen, FEL-menyvaljaren.
   * @param {MouseEvent} event
   */
  #onMouseDown = (event) => {
    if (event.button === 0) event.preventDefault();
  };

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (findModel(getModel())) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const picker = /** @type {any} */ (this.picker);
    if (!picker || typeof picker.open !== 'function') return;
    event.preventDefault();
    if (!picker.isOpen) picker.open();
  };
}

if (!customElements.get('nudient-cases-cta')) customElements.define('nudient-cases-cta', NudientCasesCta);
